<template>
	<div class="page">
		<div class="searchView">
			<div class="tabLine">
				<div class="tabItem" :class="[activeIndex=='1'?'active':'']" @click="handleSelect('1')">资产申请单</div>
				<div class="tabItem" :class="[activeIndex=='2'?'active':'']" @click="handleSelect('2')">资产管理</div>
				<div class="tabItem" :class="[activeIndex=='3'?'active':'']" @click="handleSelect('3')">资产发货单</div>
				<div class="tabItem" :class="[activeIndex=='4'?'active':'']" @click="handleSelect('4')">员工资产</div>
			</div>
		</div>
		<div class="content" v-show="activeIndex==='1'">
			<el-form class="searchBox">
				<el-row>
					<el-col :span="4">
						<el-form-item>
							<el-input style="width:130px;margin-right: 10px;" placeholder="请输入关键字" v-model="search1.keyword" clearable
							 @keyup.enter.native="changeSearch1" size="small"></el-input>
							<el-button @click="changeSearch1" type="warning" size="small">搜索</el-button>
						</el-form-item>
					</el-col>
					<el-col :span="3">
						<el-form-item label="状态" :label-width="'60px'">
							<el-select style="width:100px;" class="select" v-model="search1.state" @change="changeSearch1" placeholder="请选择"
							 size="small">
								<el-option v-for="item in [{label:'已申请',value:'1'},{label:'已完成',value:'2'}]" :key="item.value" :label="item.label"
								 :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="3">
						<el-form-item label="门店" :label-width="'60px'">
							<el-select style="width:100px;" class="select" v-model="search1.shopId" placeholder="请选择" clearable @change="changeSearch1"
							 size="small">
								<el-option v-for="item in shopsList" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="2">
						<resetBtn @reset="reset1" style="width:56px;display: inline-block;margin:0px 30px;"></resetBtn>
					</el-col>
				</el-row>
			</el-form>
			<el-table :data="tableData1" style="width: 100%">
				<el-table-column prop="no" label="申请日期" width="150" column-key="tab1key1">
					<template slot-scope="scope">
						{{scope.row.createOperationInfo.operationTime}}
					</template>
				</el-table-column>
				<el-table-column label="申请门店" width="70" column-key="tab1key2">
					<template slot-scope="scope">
						{{scope.row.shopInfo&&scope.row.shopInfo.shopName}}
					</template>
				</el-table-column>
				<el-table-column label="申请人" width="150" column-key="tab1key3">
					<template slot-scope="scope">
						{{scope.row.createOperationInfo.userName}}
					</template>
				</el-table-column>
				<el-table-column prop="zip" label="名称" width="250" column-key="tab1key4">
					<template slot-scope="scope">
						<span>{{scope.row.name}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="数量" width="90" column-key="tab1key5">
					<template slot-scope="scope">
						{{scope.row.count}}
					</template>
				</el-table-column>
				<el-table-column label="价格" width="150" column-key="tab1key6">
					<template slot-scope="scope">
						{{scope.row.money}}
					</template>
				</el-table-column>
				<el-table-column label="描述" prop="remarks" column-key="tab1key7">
					<template slot-scope="scope">
						{{scope.row.remarks}}
					</template>
				</el-table-column>
				<el-table-column label="状态" width="140" column-key="tab1key8">
					<template slot-scope="scope">
						{{scope.row.state&&scope.row.state.name}}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="120" column-key="tab1key9">
					<template slot-scope="scope">
						<el-button @click="curRow1=scope.row;drawerSeeApply_state=true" type="text" size="small">查看</el-button>
						<el-button v-if="scope.row.state.id==='1'" @click="complete1(scope.row)" type="text" size="small">完成</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div v-if="drawerSeeApply_state">
				<drawerSeeApply :id="curRow1.id" @submit="drawerSeeApply_state=false"></drawerSeeApply>
			</div>
			<page :total="page1.total" :page="page1.page" @change="changePage1" style="padding: 10px 0;"></page>
		</div>
		<div class="content" v-show="activeIndex==='2'">
			<el-form class="searchBox">
				<el-row>
					<el-col :span="4">
						<el-form-item>
							<el-input style="width:130px;margin-right: 10px;" placeholder="请输入关键字" v-model="search2.keyword" clearable
							 @keyup.enter.native="changeSearch2" size="small"></el-input>
							<el-button @click="changeSearch2" type="warning" size="small">搜索</el-button>
						</el-form-item>
					</el-col>
					<el-col :span="3">
						<el-form-item label="门店" :label-width="'60px'">
							<el-select style="width:100px;" class="select" v-model="search2.shopId" placeholder="请选择" clearable @change="changeSearch2"
							 size="small">
								<el-option v-for="item in shopsList" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="3" style="text-align: right;">
						<resetBtn @reset="reset2" style="width:56px;display: inline-block;margin:0px 30px;"></resetBtn>
					</el-col>
					<el-col :span="4" style="text-align: right;">
						<el-button v-if="$buttonAuthority('cangku2-wuliao-addzichan')" type="primary" size="small" style="display: inline-block;margin:4px 10px;" @click="curRow2={};drawerAddProduct_state=true">新建资产</el-button>
					</el-col>
				</el-row>
			</el-form>
			<el-table :data="tableData2" style="width: 100%">
				<el-table-column prop="no" label="分类" width="120" column-key="tab2key1">
					<template slot-scope="scope">
						{{scope.row.type&&scope.row.type.name}}
					</template>
				</el-table-column>
				<el-table-column label="编号" width="120" column-key="tab2key2">
					<template slot-scope="scope">
						{{scope.row.code}}
					</template>
				</el-table-column>
				<el-table-column label="名称" width="250" column-key="tab2key3">
					<template slot-scope="scope">
						<span>{{scope.row.name}}</span>
					</template>
				</el-table-column>
				<el-table-column label="规格" width="150" column-key="tab2key4">
					<template slot-scope="scope">
						<span>{{scope.row.skuName}}</span>
					</template>
				</el-table-column>
				<el-table-column label="描述" prop="remarks" column-key="tab2key5">
					<template slot-scope="scope">
						{{scope.row.remarks}}
					</template>
				</el-table-column>
				<el-table-column label="累计采购" width="100" column-key="tab2key6">
					<template slot-scope="scope">
						{{scope.row.purchaseCount}}
					</template>
				</el-table-column>
				<el-table-column label="采购总价" width="100" column-key="tab2key7">
					<template slot-scope="scope">
						{{scope.row.purchaseMoney}}
					</template>
				</el-table-column>
				<el-table-column label="库存" width="100" column-key="tab2key8">
					<template slot-scope="scope">
						{{scope.row.storage}}
						<el-tooltip effect="dark" placement="right" v-if="scope.row.storage>0">
							<div slot="content" class="tip">
								<div v-for="(item,index) in scope.row.shopStorageList" :key="index">{{item.shopInfo.shopName}}:
									{{item.storageCount}}</div>
							</div>
							<img style="width:20px;vertical-align: middle;margin-left:5px;" src="../../../assets/img/icon_eye.jpg" />
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="120" column-key="tab2key9">
					<template slot-scope="scope">
						<el-button @click="curRow2=scope.row;drawerSeeProduct_state=true" type="text" size="small">查看</el-button>
						<el-button v-if="$buttonAuthority('cangku2-wuliao-editzichan')" @click="curRow2=scope.row;drawerAddProduct_state=true" type="text" size="small">编辑</el-button>
						<el-button v-if="$buttonAuthority('cangk2u-wuliao-delzichan')" @click="del2(scope.row.id)" type="text" size="small">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div v-if="drawerAddProduct_state">
				<drawerAddProduct :id="curRow2.id" @submit="submit_drawerAddProduct"></drawerAddProduct>
			</div>
			<div v-if="drawerSeeProduct_state">
				<drawerSeeProduct :id="curRow2.id" @submit="drawerSeeProduct_state=false"></drawerSeeProduct>
			</div>
			<page :total="page2.total" :page="page2.page" @change="changePage2" style="padding: 10px 0;"></page>
		</div>
		<div class="content" v-show="activeIndex==='3'">
			<el-form class="searchBox">
				<el-row>
					<el-col :span="4">
						<el-form-item>
							<el-input style="width:130px;margin-right: 10px;" placeholder="请输入关键字" v-model="search3.keyword" clearable
							 @keyup.enter.native="changeSearch3" size="small"></el-input>
							<el-button @click="changeSearch3" type="warning" size="small">搜索</el-button>
						</el-form-item>
					</el-col>
					<el-col :span="3">
						<el-form-item label="状态" :label-width="'60px'">
							<el-select style="width:100px;" class="select" v-model="search3.state" @change="changeSearch3" placeholder="请选择"
							 size="small">
								<el-option v-for="item in [{label:'未验收',value:'1'},{label:'部分验收',value:'2'},{label:'已验收',value:'3'},{label:'取消',value:'-2'}]"
								 :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="3">
						<el-form-item label="门店" :label-width="'60px'">
							<el-select style="width:100px;" class="select" v-model="search3.shopId" placeholder="请选择" clearable @change="changeSearch3"
							 size="small">
								<el-option v-for="item in shopsList" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="发货日期" :label-width="'90px'">
							<el-date-picker @change="changeSearch3" v-model="datetimerange3" type="daterange" range-separator="至"
							 start-placeholder="开始日期" end-placeholder="结束日期" size="small" style="width: 220px;">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="6" style="text-align: right;">
						<resetBtn @reset="reset3" style="width:56px;display: inline-block;margin:0px 10px;"></resetBtn>
						<el-button  v-if="$buttonAuthority('cangku2-wuliao-addfahuo')"  @click="$router.push({path:'/wuliao/invoiceAdd'})" type="primary" size="small" style="margin:0px 30px;">新建发货单</el-button>
					</el-col>
				</el-row>
			</el-form>
			<el-table :data="tableData3" style="width: 100%">
				<el-table-column prop="no" label="发货单号" column-key="tab3key1">
					<template slot-scope="scope">
						{{scope.row.purchaseNo}}
					</template>
				</el-table-column>
				<el-table-column label="发货时间" column-key="tab3key2">
					<template slot-scope="scope">
						{{scope.row.createOperationInfo.operationTime}}
					</template>
				</el-table-column>
				<el-table-column label="采购人" column-key="tab3key3">
					<template slot-scope="scope">
						{{scope.row.createOperationInfo.userName}}
					</template>
				</el-table-column>
				<el-table-column label="发往门店" column-key="tab3key4">
					<template slot-scope="scope">
						<span>{{scope.row.shopInfo.shopName}}</span>
					</template>
				</el-table-column>
				<el-table-column label="状态" column-key="tab3key5">
					<template slot-scope="scope">
						{{scope.row.state.name}}
					</template>
				</el-table-column>
				<el-table-column label="验收日期" column-key="tab3key6">
					<template slot-scope="scope">
						{{scope.row.updateOperationInfo&&scope.row.updateOperationInfo.operationTime}}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="120" column-key="tab3key7">
					<template slot-scope="scope">
						<el-button @click="$router.push({path:'/wuliao/invoiceSee',query:{id:scope.row.id}})" type="text" size="small">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
			<page :total="page3.total" :page="page3.page" @change="changePage3" style="padding: 10px 0;"></page>
		</div>
		<!-- 员工资产 -->
		<div class="content" v-show="$buttonAuthority('cangku2-wuliao-staffzichan')&&activeIndex==='4'">
			<el-form class="searchBox">
				<el-row>
					<el-col :span="4">
						<el-form-item>
							<el-input style="width:130px;margin-right: 10px;" placeholder="资产名称/员工" v-model="search4.keyword" clearable
							 @keyup.enter.native="changeSearch4" size="small"></el-input>
							<el-button @click="changeSearch4" type="warning" size="small">搜索</el-button>
						</el-form-item>
					</el-col>
					<el-col :span="3">
						<el-form-item label="门店" :label-width="'60px'">
							<el-select style="width:100px;" class="select" v-model="search4.shopId" placeholder="请选择" clearable @change="changeSearch4"
							 size="small">
								<el-option v-for="item in shopsList" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="2">
						<resetBtn @reset="reset4" style="width:56px;display: inline-block;margin:0px 30px;"></resetBtn>
					</el-col>
				</el-row>
			</el-form>
			<el-table :data="tableData4" style="width: 100%">
				<el-table-column prop="no" label="门店" column-key="tab4key1">
					<template slot-scope="scope">
						{{$public.getShopNameById(scope.row.shopId)}}
					</template>
				</el-table-column>
				<el-table-column label="员工" >
					<template slot-scope="scope">
						{{scope.row.staffId?scope.row.staffId:''}}
					</template>
				</el-table-column>
				<el-table-column label="负责资产" column-key="tab4key3">
					<template slot-scope="scope">
						{{scope.row.lockCount}}
					</template>
				</el-table-column>
				<el-table-column label="操作" column-key="tab4key4">
					<template slot-scope="scope">
						<el-button @click="$router.push({path:'/wuliao/assetsSee',query:{info:scope.row}})" type="text" size="small">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
			<page :total="page4.total" :page="page4.page" @change="changePage4" style="padding: 10px 0;"></page>
		</div>
	</div>
</template>
<script>
	import page from "../../../components/page.vue"
	import resetBtn from "../../../components/resetBtn.vue"
	import drawerAddProduct from "./drawer_addProduct.vue"
	import drawerSeeProduct from "./drawer_seeProduct.vue"
	import drawerSeeApply from "./drawer_seeApply.vue"
	export default {
		components: {
			page,
			resetBtn,
			drawerAddProduct,
			drawerSeeProduct,
			drawerSeeApply
		},
		data() {
			return {
				activeIndex: '1',
				// 资产申请单
				search1: {
					"keyword": "",
					"starttime": "",
					"endtime": "",
					"state": '', // 1 已申请 2已完成
					shopId: '',
				},
				shopsList: this.$store.getters.shopList,
				datetimerange1: [],
				page1: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				tableData1: [],
				drawerSeeApply_state: false, // 查看
				curRow1: {},
				// 资产管理
				search2: {
					"keyword": "",
					"shopId": "", // 用户id
				},
				datetimerange2: [],
				page2: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				tableData2: [],
				drawerSeeProduct_state: false, // 查看资产
				drawerAddProduct_state: false, // 新增资产
				curRow2: {},
				// 资产发货单
				search3: {
					"keyword": "",
					"shopId": "", // 
					"state": '', // 1 未验收 2部分验收 3 已验收 -2 取消
				},
				datetimerange3: [],
				page3: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				tableData3: [],

				// 员工资产
				search4: {
					"keyword": "",
					'shopId': '5e9412e0b2bfbc089daerr12',
					'staffId': '',
				},
				datetimerange4: [],
				page4: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				tableData4: [],
				physicalShops: [{
						shopId: '5e9412e0b2bfbc089daerr12',
						shopName: '北环'
					},
					{
						shopId: '5e9412e0b2bfbc089daerr13',
						shopName: '陇海'
					},
					{
						shopId: '5e9412e0b2bfbc089daerr15',
						shopName: '东区'
					},
					{
						shopId: '5e9412e0b2bfbc089daerr16',
						shopName: '二七'
					},
					{
						shopId: '5e9412e0b2bfbc089daerr18',
						shopName: '云尚'
					},
				],
			}
		},
		computed: {
			curShopId() {
				return this.$store.state.shopId;
			},
			// getShopName(shopId) {
			// 	for (var i = 0; i < this.physicalShops.length; i++) {
			// 		if (shopId == this.physicalShops[i].shopId) {
			// 			return this.physicalShops[i].shopName;
			// 		}
			// 	}
			// }
		},
		mounted() {
			// console.log(this.shopsList)
			this.getTableData1();
			this.getTableData4();
		},
		methods: {
			//tab切换
			handleSelect(str) {
				if (this.activeIndex === str) return
				this.activeIndex = str;
				this['getTableData' + str]()
			},
			// 资产申请单
			reset1() {
				this.page1.page = 1;
				this.search1.keyword = '';
				this.search1.state = '';
				this.search1.shopId = '';
				this.getTableData1();
			},
			changeSearch1() {
				this.page1.page = 1;
				this.getTableData1()
			},
			changePage1(num) {
				this.page1.page = num;
				this.getTableData1();
			},
			getTableData1() {
				let loading = this.$loading();
				let params = {
					"keyWord": this.search1.keyword,
					"type": "", // 资产类型
					"shopId": this.search1.shopId, // 门店id
					"state": this.search1.state, //  1 已申请 2已完成
					"pageIndex": this.page1.page,
					"pageSize": this.page1.pageSize,
				}
				// if (this.datetimerange && this.datetimerange.length == 2) {
				// 	params.starttime = ('' + new Date(this.datetimerange[0]).getTime()).substr(0, 10);
				// 	params.endtime = ('' + new Date(this.datetimerange[1]).getTime()).substr(0, 10);
				// }
				this.$http.post(process.env.VUE_APP_zichan + '/api/AssetsRequest/list', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData1 = res.data.list;
						this.page1.total = res.data.count;
					}
				})
			},
			// 资产管理
			reset2() {
				this.page2.page = 1;
				this.search2.keyword = '';
				this.search2.shopId = '';
				this.getTableData2();
			},
			changeSearch2() {
				this.page2.page = 1;
				this.getTableData2()
			},
			changePage2(num) {
				this.page2.page = num;
				this.getTableData2();
			},
			getTableData2() {
				let loading = this.$loading();
				let params = {
					"keyWord": this.search2.keyword,
					"type": "",
					"shopId": this.search2.shopId,
					"isHaveStorage": false,
					"pageIndex": this.page2.page,
					"pageSize": this.page2.pageSize,
				}
				// if (this.datetimerange && this.datetimerange.length == 2) {
				// 	params.starttime = ('' + new Date(this.datetimerange[0]).getTime()).substr(0, 10);
				// 	params.endtime = ('' + new Date(this.datetimerange[1]).getTime()).substr(0, 10);
				// }
				this.$http.post(process.env.VUE_APP_zichan + '/api/AssetsInfo/list', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData2 = res.data.list;
						this.page2.total = res.data.count;
					}
				})
			},
			submit_drawerAddProduct(obj) {
				this.drawerAddProduct_state = false;
				if (obj.type === 'success') {
					this.getTableData2()
				}
			},
			// 资产发货单
			reset3() {
				this.page3.page = 1;
				this.search3.keyword = '';
				this.search3.shopId = '';
				this.search3.state = '';
				this.datetimerange3 = [];
				this.getTableData3();
			},
			changeSearch3() {
				this.page3.page = 1;
				this.getTableData3()
			},
			changePage3(num) {
				this.page3.page = num;
				this.getTableData3();
			},
			getTableData3() {
				let loading = this.$loading();
				let params = {
					"keyWord": this.search3.keyword,
					"shopId": this.search3.shopId,
					"state": this.search3.state,
					"assetsCode": "",
					"assetsType": "",
					beginTime: '',
					endTime: '',
					"pageIndex": this.page3.page,
					"pageSize": this.page3.pageSize,
				}
				if (this.datetimerange3 && this.datetimerange3.length == 2) {
					params.beginTime = new Date(this.datetimerange3[0])
					params.endTime = new Date(this.datetimerange3[1])
				}
				this.$http.post(process.env.VUE_APP_zichan + '/api/AssetsPurchase/list', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData3 = res.data.list;
						this.page3.total = res.data.count;
					}
				})
			},




			complete1(row) {
				this.$confirm('确定已完成该申请单?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let loading = this.$loading()
					this.$http.get(process.env.VUE_APP_zichan + '/api/AssetsRequest/accomplish', {
						id: row.id
					}).then(res => {
						loading.close()
						if (res.code == 0) {
							this.getTableData1()
						}
					})
				})
			},
			// 删除
			del2(id) {
				this.$confirm('确定删除该资产?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let loading = this.$loading()
					this.$http.get(process.env.VUE_APP_zichan + '/api/AssetsInfo/delete', {
						id: id
					}).then(res => {
						loading.close()
						if (res.code == 0) {
							this.getTableData2()
						}
					})
				})
			},
			// 获取员工资产列表
			getTableData4() {
				let loading = this.$loading();
				let params = {
					"keyWord": this.search4.keyword,
					"shopId": this.search4.shopId,
					'staffId': this.search4.staffId,
				}
				this.$http.get(process.env.VUE_APP_zichan + '/api/AssetsStaff/list', params).then(res => {
					loading.close()
					console.log('员工资产', res)
					if (res.code == 0) {
						this.tableData4 = res.data;
						this.page4.total = res.data.length;
					}
				})
			},
			// 搜索条件
			reset4() {
				this.search4.keyword = '';
				this.search4.shopId = '5e9412e0b2bfbc089daerr12';
				this.getTableData4();
			},
			changeSearch4() {
				this.page4.page = 1;
				this.getTableData4()
			},
			changePage4(num) {
				this.page4.page = num;
				this.getTableData4();
			},
		}
	}
</script>
<style scoped lang="scss">
	.page {
		height: 100%;

		.searchView {

			.tabLine {
				display: flex;

				.tabItem {
					width: 88px;
					box-sizing: border-box;
					line-height: 36px;
					text-align: center;
					border-right: 1px solid #F2F2F2;
					cursor: pointer;
					font-size: 14px;
					background-color: #fff;

					&.active {
						color: $mainColor;
					}
				}
			}

			.searchBox {
				border-top: 1px solid #F2F2F2;
			}
		}

		.content {
			padding: 0 0px;
			height: calc(100% - 36px);

			::v-deep .el-form-item {
				margin-bottom: 0;

				.el-form-item__label {
					padding-right: 5px;
					font-size: 12px;
				}
			}
		}
	}
</style>
